import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IdentificationSearchResult} from "../../../record/identification-models";
import {IdWithIndex} from "../default-customer.module";
import {isValidMatchOutcome, MATCH_OUTCOME} from "../../../../constants/match-outcome.enum";

@Component({
  selector: 'default-identification-list',
  templateUrl: './default-identifications-list-view.component.html',
  styleUrls: ['./default-identifications-list-view.component.scss']
})
export class DefaultIdentificationsListViewComponent {

  @Input() identificationResults: IdentificationSearchResult[] = [];
  @Input() currentIdentificationId: string | null = null;
  @Input() dataset: string | null = null;
  @Input() isSuperuser: boolean = false;

  @Output() setIdentificationEvent: EventEmitter<IdWithIndex> = new EventEmitter<IdWithIndex>();

  protected readonly matchOutcome = MATCH_OUTCOME;
  protected readonly isValidMatchOutcome = isValidMatchOutcome;
}

